<template>
    <div>
        <div class="component-title-box" v-if="config && config.title">
            <div class="title-box-wrapper">
                <span class="title">{{ t(config.title) }}</span>
                <span class="icon icon-help help-icon" v-popover:tooltip="t(config.description)" v-if="config.description"></span>
            </div>
            <hr class="line">
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        config: {
            Type: Object
        },
    },
    data()
    {
        return {
            descriptionShow: false,
        };
    },
    mounted()
    {
    },
    methods: {
    },
}

</script>

<style scoped>
    hr.line {
        margin: 10px 0 10px 0;
        border: 0;
        height: 2px;
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
    }
    .title {
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// ComponentTitle.vue?68ca8368